import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MaterialModule } from 'src/app/core/material.module';

import { TestRoomStatusEnum } from 'src/app/core/enums';
import { AbilityService } from 'src/app/core/services/ability/ability.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ALL_TEST_ROOM_STATUS_OPTIONS } from 'src/app/features/tests/features/constants';
import { RootAnnotation } from 'src/app/features/working-area/interfaces';
import { DepartmentSelectComponent } from '../../../departments/components/department-select/department-select.component';
import { TestRoomService } from '../../services/test-rooms.service';
import { trackFeatureUse } from 'src/app/core/analytics';

@Component({
  selector: 'app-add-test-rooms-dialog',
  templateUrl: 'test-rooms-dialog.component.html',
  styleUrls: ['test-rooms-dialog.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    DepartmentSelectComponent,
  ],
})
export class AddTestRoomsDialogComponent implements OnInit {
  form: FormGroup;
  public isLoading: boolean;
  isDepartmentDisabled: boolean = false;
  constructor(
    public ability: AbilityService,
    private notificationService: NotificationService,
    public testRoomService: TestRoomService,
    public dialogRef: MatDialogRef<AddTestRoomsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RootAnnotation,
  ) {}

  allTestRoomStatusOptions = ALL_TEST_ROOM_STATUS_OPTIONS;

  ngOnInit() {
    this.form = new FormGroup({
      name: new FormControl('', []),
      hasCamera: new FormControl(true),
      hasTablet: new FormControl(false),
      status: new FormControl(TestRoomStatusEnum.AVAILABLE),
      active: new FormControl(true),
      departmentId: new FormControl(true),
    });


    if (!this.ability.isDepartmentVisible) {
      this.form.patchValue({
        departmentId: this.ability.departmentId,
      });
      this.isDepartmentDisabled = true;
    }
  }

  onClose() {
    this.dialogRef.close(null);
  }

  save() {
    trackFeatureUse('test_rooms', 'saved');
    this.isLoading = true;

    if (this.form.invalid) {
      this.isLoading = false;
      return;
    }

    const payload = this.form.value;
    this.testRoomService.create(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.dialogRef.close(res);
        this.notificationService.success('Created Successfully test room');
      },
      error: () => {
        this.dialogRef.close(null);
        this.notificationService.error('Error creating test room');
        this.isLoading = false;
      },
    });
  }

  onDepartmentChange(value: string) {
    this.form.get('departmentId')?.setValue(value);
  }
}
